import React from 'react';
import Contact from '../Contact/Contact';
import Accordion from './Accordion/Accordion'
import Partner from '../Partner/Slider'
import HomePage from './HomePage/HomePage';
export default function Home(){
    return (
        <>
        {/* <Accordion/> */}
        <HomePage/> 
        <Partner/>
        <Contact/>
        </>
    )
}